export const parentChildCommunication = {
    methods: {
        setParentProp(prop, val) {
            this.$emit("set-parent-prop", [prop, val]);
        },
        propSetFromChild(event) {
            const prop = event[0];
            const val = event[1];
            if (this.hasOwnProperty("$props") && this.$props.hasOwnProperty(prop)) {
                this.setParentProp(prop, val);
            } else {
                if (this.hasOwnProperty(prop)) {
                    this.$set(this, prop, val);
                }
            }
        },
    },
};
